"use client";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import React, { ComponentProps } from "react";


export type BackdropProps = {
  theme?: 'light'|'dark',
  type?: 'full'|'panel'|'popup',
} & ComponentProps<typeof motion.div>;

const Backdrop = ({ children = undefined, onClick, theme = 'light', className, type, ...props  }:BackdropProps) => {
  const css = [styles.backdrop, className,];
  if (theme == "light") css.push(styles.light);
  if (type == "full") css.push(styles.transparent);
  return (
    <motion.div
      onClick={onClick}
      className={css.filter(t => !!t).join(' ')  }
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 , transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 }} }
      {...props}
    >
      {!!children && children}
    </motion.div>
  );
};

export default Backdrop;
